export const appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#e10600',
    colorBackground: '#f7f4f1',
    colorText: '#30313d',
    colorDanger: '#df1b41',
    fontFamily: '"titillium", "Helvetica", sans-serif',
    spacingUnit: '4px',
    borderRadius: '0',
    colorSuccess: 'green',
    spacingAccordionItem: '500px'
  },
  rules: {
    '.AccordionItem': {
      backgroundColor: '#fff',
      border: '1px solid #ccc',
    },
    '.Input': {
      backgroundColor: '#fff',
      boxShadow: 'none',
      border: '1px solid #cccccc',
      padding: '10px 12px',
      fontSize: '13px',
      lineHeight: '15px',
    },
    '.Label': {
      fontFamily: '"titillium", "Helvetica", sans-serif',
      fontSize: '14px',
      fontWeight: '300',
      color: 'rgb(102, 102, 102)'
    },
    '.PickerItem': {
      fontFamily: '"titillium", "Helvetica", sans-serif',
      fontSize: '14px',
      fontWeight: '300',
      color: 'rgb(102, 102, 102)'
    },
  }
}